import axios from "axios";
import { useEffect, useState } from "react";

export default ({ column, onChange, initialData }) => {
    const [options, setOptions] = useState([])
    const id = Math.random().toString(36).substring(2, 15);

    useEffect(() => {
        axios.get("/customQuery", {
            params: {
                query: column.autocompleteListQuery
            }
        }).then((response) => {
            setOptions(response.data.map(x => x[column.autocompleteListQueryResultKey]))
        })
    }, [])

    return (
        <>
            <input
                type="text"
                onChange={(e) => onChange({ [column.name]: e.target.value })}
                defaultValue={initialData?.[column.name]}
                list={id}
            />
            <datalist id={id}>
                {options.map((option) => (
                    <option value={option} key={option}></option>
                ))}
            </datalist>
        </>
    );
}